import { HttpService } from '@/infra/http'
import type { TCliente } from '@/types/cliente'

export class GetClientePorIdService extends HttpService {
  async execute({ id }: { id: string }) {
    return this.http.get<TCliente>(`api/v2/Cliente/${id}`)
  }
}
